import React from 'react';
import { AlertCircleIcon } from './Icons';
import './RejectDialog.css';

const RejectDialog = ({ isOpen, title, message, confirmText = 'Reject', cancelText = 'Cancel', value, onChange, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!value || !value.trim()) {
      return;
    }
    onConfirm();
  };

  return (
    <div className="reject-dialog-overlay" onClick={onCancel}>
      <div className="reject-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="reject-dialog__header">
          <div className="reject-dialog__icon-wrapper">
            <AlertCircleIcon className="reject-dialog__icon reject-dialog__icon--danger" size={24} />
          </div>
          <h3 className="reject-dialog__title">{title}</h3>
        </div>
        <div className="reject-dialog__content">
          <p className="reject-dialog__message">{message}</p>
          <textarea
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter rejection reason..."
            className="reject-dialog__textarea"
            rows="5"
            autoFocus
          />
        </div>
        <div className="reject-dialog__actions">
          <button
            onClick={onCancel}
            className="reject-dialog__btn reject-dialog__btn--cancel"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className="reject-dialog__btn reject-dialog__btn--danger"
            disabled={!value || !value.trim()}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectDialog;










